<template>
    <div style="background: #fff;">
        <div class="batch_header" v-if="!store.state.isH5">
            <img src="@/assets/image/图标-20.png" alt="" @click="backEvent" />
            <div>上报成功</div>
        </div>
        <div class="report_success_box">
            <div class="report_success_icon">
                <img src="@/assets/image/select_succ.png" >
                <div>上报成功</div>
            </div>
            <div class="report_success_info">
                <div>您可在<span @click="goToReportList">上报记录</span>中查看本次上报</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';
const router = useRouter()
const { beacon } = getCurrentInstance().appContext.config.globalProperties;
const goToReportList = () => {
    beacon.onUserAction("record_click")
    router.replace('/message_appear_history')
}
const store = useStore();
const backEvent = () => {
    router.go(-1)
}
</script>
<style lang='scss' scoped>
.batch_header{
    padding: 35px 0 10px;
    position: relative;
    box-shadow: 0px 2px 14px rgba(0, 136, 255, $alpha: 0.08);
    img{
        position: absolute;
        top: 35px;
        left: 20px;
        width: 20px;
        height: 20px;
    }
    div{
        text-align: center;
        font-size: 16px;
        font-weight: 700;
    }
}
.report_success_box{
    padding-top: 37px;
    text-align: center;
    .report_success_icon{
        img{
            width: 48px;
            height: 48px;
        }
        div{
            margin-top: 12px;
            font-weight: 700;
            font-size: 16px;
        }
    }
    .report_success_info{
        margin-top: 67px;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        color: #17181a;
        opacity: 0.7;
        span{
            color: #0088ff;
        }
    }
}
</style>